import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/views/index/index';
import BrandStory from '@/views/brandStory/brandStory';
import Information from '@/views/information/information';
import Contact from '@/views/contact/contact';
import Home from '@/views/home';

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Index',
			component: Index,
		},
		{
			path: '/brandStory',
			name: 'BrandStory',
			component: BrandStory,
		},
		{
			path: '/information',
			name: 'Information',
			component: Information,
		},
		{
			path: '/contact',
			name: 'Contact',
			component: Contact,
		},
		{
			path: '/shop/list',
			name: 'ShopList',
			component: () => import('@/views/shop/list'),
		},
		{
			path: '/shop/detail/:id',
			name: 'ShopDetail',
			component: () => import('@/views/shop/detail'),
		},
		{
			path: '/shop/order',
			name: 'ShopOrder',
			component: () => import('@/views/shop/order'),
		},
		{
			path: '/home',
			name: 'Home',
			component: Home,
			children: [
				{
					path: 'myTestPaper',
					name: 'MyTestPaper',
					component: () => import('@/views/exam/exam'), //懒加载
				},
				{
					path: 'myVideo',
					name: 'MyVideo',
					component: () => import('@/views/myVideo'), //懒加载
				},
				{
					path: 'myWatch',
					name: 'MyWatch',
					component: () => import('@/views/myVideo/watch1'), //懒加载
				},
				{
					path: 'myEbook',
					name: 'MyEbook',
					component: () => import('@/views/myEbook'), //懒加载
				},
				{
					path: 'errorCollect',
					name: 'ErrorCollect',
					component: () => import('@/views/errorCollect'), //懒加载
				},
				{
					path: 'collectQuestions',
					name: 'CollectQuestions',
					component: () => import('@/views/collectQuestions'), //懒加载
				},
			],
		},
	],
});



// WEBPACK FOOTER //
// ./src/router/index.js